import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import useRichText from 'hooks/useRichText'

import Media from '../Media'

import * as styles from './text.module.scss'

/**
 * @param {object} props
 * @param {(string | object)} props.hat
 * @param {string} props.hatAs
 * @param {(string | object)} props.title
 * @param {string} props.titleAs
 * @param {(string | object)} props.subtitle
 * @param {string} props.subtitleAs
 * @param {function} props.cta button or cta?
 */

const Text = ({
  hatIcon,
  hat,
  title,
  subtitle,
  hatAs = 'h6',
  titleAs = 'h2',
  subtitleAs = 'body-2',
  // cta = null,
  custom,
  underlineTitle = false,
  underlineSubtitle = false,
  ...other
}) => {
  const renderHat = useRichText({
    text: hat,
    className: classNames(styles.hat, 'hat'),
    as: hatAs,
  })

  const renderTitle = useRichText({
    text: title,
    className: classNames(styles.title, 'title'),
    as: titleAs,
    underline: underlineTitle,
  })

  const renderSubtitle = useRichText({
    text: subtitle,
    className: classNames(styles.subtitle, 'subtitle'),
    as: subtitleAs,
    underline: underlineSubtitle,
  })

  return (
    <div className={styles.text} {...other}>
      <div className={classNames(styles.textWrap, 'text-wrap')}>
        {hatIcon && (
          <div className="hatIconWrap">
            <Media
              className="hatIcon"
              media={hatIcon}
              alt={hatIcon.description}
            />
          </div>
        )}

        {renderHat}
        {renderTitle}
        {renderSubtitle}

        {/* {cta && <div className="cta">{cta}</div>} */}

        {custom && <div className="customWrap">{custom()}</div>}
      </div>
    </div>
  )
}

Text.propTypes = {
  hat: PropTypes.oneOfType([
    PropTypes.shape({
      raw: PropTypes.string.isRequired,
    }),
    PropTypes.string,
  ]),
  hatAs: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.shape({
      raw: PropTypes.string.isRequired,
    }),
    PropTypes.string,
  ]),
  titleAs: PropTypes.string,
  subtitle: PropTypes.oneOfType([
    PropTypes.shape({
      raw: PropTypes.string.isRequired,
    }),
    PropTypes.string,
  ]),
  subtitleAs: PropTypes.string,
  cta: PropTypes.func,

  textAlign: PropTypes.string,
}

export default Text
